// Dependency imports
import { Search } from 'lucide-react';

interface EnhancedTableToolbarProps {
  setRow?: any;
  rows?: any[];
  setExpandedRowIndex?: any;
  searchVal?: string;
  setSearchVal?: any;
  setPage?: any;
  setIsRowEditing?: any;
}

const EnhancedTableToolbar = ({
  setRow,
  rows,
  setExpandedRowIndex,
  searchVal,
  setSearchVal,
  setPage,
  setIsRowEditing
}: EnhancedTableToolbarProps) => {
  const handleSearch = (searchVal: string) => {
    setIsRowEditing(false);
    if (searchVal === '') {
      if (rows) {
        setRow(rows);
        return;
      }
    }

    const filterBySearch = rows?.filter((item: any) => {
      if (
        typeof item.name === 'string' &&
        item.name.toLowerCase().includes(searchVal.toLowerCase())
      ) {
        return item;
      }
    });
    setRow(filterBySearch);
  };

  return (
    <div className="flex flex-row w-[20vw] items-center justify-start">
      <div className="px-2 w-full flex items-center bg-[#EBEBEB] border rounded-sm gap-2 py-1.5 ">
        <Search className="w-[1.1vw] h-auto" />
        <input
          type="text"
          value={searchVal}
          onChange={e => {
            setSearchVal(e.target.value);
            setExpandedRowIndex(null);
            setPage(0);
            handleSearch(e.target.value);
          }}
          className="w-full flex-1 text-[0.8vw] bg-[#EBEBEB] focus:outline-none"
          placeholder="Search by Name"
        />
      </div>
    </div>
  );
};

export default EnhancedTableToolbar;
